
const LotInfo = ({ name, fee }) => {
  return (
    <div className='p-12 bg-secondary rounded-xl mb-20'>
      <h4 className='mb-4'>Lot Data:</h4>
      <div className='flex justify-between items-center'>
        <span>Lot name:</span>
        <span>{name}</span>
      </div>
      <div className='flex justify-between items-center'>
        <span>Fee:</span>
        <span>
          ${fee}</span>
      </div>
    </div>
  )
}

export default LotInfo